import clsx, { ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";


// Capture the referrer (previous subdomain) before redirection
export const getReferrer = () => {
    // Check if the referrer is from a different subdomain (or domain)
    const referrer = document.referrer;
    if (referrer) {
        const referrerDomain = new URL(referrer).hostname;
        const currentDomain = window.location.hostname;

        // If the referrer is from a different subdomain of the same domain, store it
        if (referrerDomain !== currentDomain) {
            localStorage.setItem('redirectTo', referrer);
        }
    }
};

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const MOCK_ROLE_PERMISSIONS: Record<string, Record<string, string[]>> = {
    "Backend Admin": {
        SystemMonitoring: ["manage"],
        SystemManagement: ["manage"],
        AuditLogs: ["manage"],
        BackupRestore: ["manage"],
        UserManagement: ["manage"],
        RolePermissionManagement: ["manage"],
        WebhookConfig: ["manage"],
        APIManagement: ["manage"],
        IntegrationLogs: ["manage"],
        NotificationSystem: ["manage"],
        DeveloperConsole: ["manage"],
        DataPrivacyCompliance: ["manage"],
        AppSettings: ["edit"],
    },
    Developer: {
        AppSettings: ["edit"],
        UserManagement: ["view"],
        RolePermissionManagement: ["view"],
        WebhookConfig: ["manage"],
        APIManagement: ["manage"],
        SystemMonitoring: ["view"],
        IntegrationLogs: ["view"],
        AuditLogs: ["view"],
        NotificationSystem: ["view"],
        BackupRestore: ["view"],
        DeveloperConsole: ["manage"],
        DataPrivacyCompliance: ["view"],
        KmstackABInvoice: ["view"],
        KmstackABFinancialReport: ["view"],
    },
    "Accounting Admin": {
        KmstackABEmployee: ["manage"],
        KmstackABPayslip: ["manage"],
        KmstackABPayroll: ["manage"],
        EmployeePayslipPortal: ["manage"],
        EmployeeTaxSummary: ["manage"],
        LeaveAndAbsenceTracking: ["manage"],
        KmstackABTaxReport: ["manage"],
        KmstackABVATReport: ["manage"],
        KmstackABTaxFiling: ["manage"],
        KmstackABFinancialReport: ["manage"],
        KmstackABInvoice: ["manage"],
        KmstackABRecurringInvoice: ["manage"],
        KmstackABCryptoPayment: ["manage"],
        KmstackABCryptoWallet: ["manage"],
        KmstackABInvoicePayment: ["manage"],
        KmstackABChartOfAccounts: ["manage"],
        KmstackABGeneralLedger: ["manage"],
        KmstackABInvoiceCategoryPrediction: ["manage"],
        KmstackABPaymentReminder: ["manage"],
        KmstackABProject: ["manage"],
        KmstackABTimeLog: ["manage"],
        KmstackABCarbonOffset: ["manage"],
        KmstackABFraudAlert: ["manage"],
        UserManagement: ["manage"],
        ClientManagement: ["manage"],
        AccountantManagement: ["manage"],
        EmployeeManagement: ["manage"],
    },
    Accountant: {
        KmstackABPayslip: ["manage"],
        KmstackABPayroll: ["manage"],
        KmstackABTimesheet: ["manage"],
        EmployeePayslipPortal: ["view"],
        EmployeeTaxSummary: ["view"],
        KmstackABTaxReport: ["manage"],
        KmstackABVATReport: ["manage"],
        KmstackABTaxFiling: ["manage"],
        KmstackABFinancialReport: ["view"],
        KmstackABInvoice: ["view"],
        KmstackABRecurringInvoice: ["view"],
        KmstackABCryptoPayment: ["view"],
        KmstackABCryptoWallet: ["view"],
        KmstackABInvoicePayment: ["view"],
        KmstackABChartOfAccounts: ["view"],
        KmstackABGeneralLedger: ["view"],
        KmstackABInvoiceCategoryPrediction: ["view"],
        KmstackABPaymentReminder: ["view"],
        KmstackABProject: ["view"],
        KmstackABTimeLog: ["view"],
        KmstackABCarbonOffset: ["view"],
        KmstackABFraudAlert: ["view"],
    },
    HR: {
        KmstackABEmployee: ["manage"],
        KmstackABPayslip: ["view"],
        KmstackABPayroll: ["view"],
        EmployeePayslipPortal: ["view"],
        EmployeeTaxSummary: ["view"],
        LeaveAndAbsenceTracking: ["manage"],
        KmstackABInvoice: ["view"],
        KmstackABRecurringInvoice: ["view"],
        KmstackABCryptoPayment: ["view"],
        KmstackABCryptoWallet: ["view"],
        KmstackABInvoicePayment: ["view"],
        KmstackABChartOfAccounts: ["view"],
        KmstackABGeneralLedger: ["view"],
        KmstackABInvoiceCategoryPrediction: ["view"],
        KmstackABPaymentReminder: ["view"],
        KmstackABProject: ["view"],
        KmstackABTimeLog: ["view"],
        KmstackABCarbonOffset: ["view"],
        KmstackABFraudAlert: ["view"],
    },
    Employee: {
        KmstackABEmployee: ["view"],
        KmstackABPayslip: ["view"],
        KmstackABPayroll: ["view"],
        EmployeePayslipPortal: ["view"],
        EmployeeTaxSummary: ["view"],
        LeaveAndAbsenceTracking: ["view"],
        KmstackABTimesheet: ["edit"],
        KmstackABMessage: ["create"],
        KmstackABInvoice: ["view"],
        KmstackABRecurringInvoice: ["view"],
        KmstackABCryptoPayment: ["view"],
        KmstackABCryptoWallet: ["view"],
        KmstackABInvoicePayment: ["view"],
    },
    Viewer: {
        KmstackABEmployee: ["view"],
        KmstackABPayslip: ["view"],
        KmstackABPayroll: ["view"],
        EmployeePayslipPortal: ["view"],
        EmployeeTaxSummary: ["view"],
        LeaveAndAbsenceTracking: ["view"],
        KmstackABInvoice: ["view"],
        KmstackABTaxReport: ["view"],
        KmstackABFinancialReport: ["view"],
        KmstackABChartOfAccounts: ["view"],
        KmstackABGeneralLedger: ["view"],
        KmstackABInvoiceCategoryPrediction: ["view"],
    },
};


export const fetchRolePermissions = async (role: string): Promise<Record<string, string[]>> => {
    // Simulate backend delay
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve(MOCK_ROLE_PERMISSIONS[role] || {});
        }, 300); // simulate API latency
    });
};

